export default "__VITE_ASSET__fQDBftJ___ 430w";